export enum Language {
  en = 'en',
  es = 'es',
  pt = 'pt',
  it = 'it',
  fr = 'fr',
  de = 'de',
  zh = 'zh'
}